import css from './index.module.scss';
import { getLang } from 'lowcomp/plugins/member/utils';
import { i18n } from '../i18n';
import { useRouter } from 'next/router';

export default function ViewModal({ text, callback }: any) {
    const { locale } = useRouter();
    const t = getLang(i18n, locale);

    return (
        <div className={`flash-sale-view-modal ${css['view-modal']}`}>
            <div className="content">
                <span className="close" onClick={callback}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M8 6.66675L25.3333 24.0001M25.3333 6.66675L8 24.0001"
                            stroke="black"
                            strokeWidth="2.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </span>
                <div className="inner">
                    <p className="title">{t('view_step_modal_title')}</p>
                    <p className="text">{text}</p>
                </div>
            </div>
        </div>
    );
}
